import { useState, useEffect } from 'react';
import { Heart, Loader2, CheckCircle } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import { useAuth } from '../../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PeriodicCheckin() {
  const { user } = useAuth();
  const [sending, setSending] = useState(false);
  const [lastCheckin, setLastCheckin] = useState(null);

  const token = typeof window !== 'undefined' ? localStorage.getItem('lifelink_token') : null;

  useEffect(() => {
    if (user?.ultimo_checkin) setLastCheckin(user.ultimo_checkin);
  }, [user]);

  const sendCheckin = async () => {
    setSending(true);
    try {
      const { data } = await axios.post(`${API}/checkin/periodic`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLastCheckin(data.created_at);
      toast.success('Check-in inviato. Grazie!');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Errore');
    } finally { setSending(false); }
  };

  if (!user) return null;

  const hoursSince = lastCheckin ? (Date.now() - new Date(lastCheckin).getTime()) / 3600000 : null;
  const needsCheckin = !lastCheckin || hoursSince > 24;

  return (
    <div className="border border-[#B8D4E8] bg-white p-4" data-testid="periodic-checkin">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-3">
          <div className={`w-10 h-10 flex items-center justify-center ${needsCheckin ? 'bg-[#FF9F0A]/10 text-[#FF9F0A]' : 'bg-[#32D74B]/10 text-[#32D74B]'}`}>
            <Heart size={18} />
          </div>
          <div>
            <div className="text-xs font-bold uppercase tracking-widest text-[#0D1B2A]">Check-in Periodico</div>
            <div className="text-[11px] text-[#4A6B8A]">
              {lastCheckin
                ? `Ultimo: ${new Date(lastCheckin).toLocaleString('it-IT', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}`
                : 'Nessun check-in ancora'}
            </div>
          </div>
        </div>
        <button
          onClick={sendCheckin}
          disabled={sending}
          className={`flex items-center gap-2 px-4 py-2 text-xs font-bold uppercase tracking-widest transition-all disabled:opacity-40 ${
            needsCheckin
              ? 'bg-[#FF3B30] text-white hover:bg-[#FF1A1A]'
              : 'border border-[#32D74B] text-[#32D74B] hover:bg-[#32D74B]/10'
          }`}
          data-testid="periodic-checkin-btn"
        >
          {sending ? <Loader2 size={14} className="animate-spin" /> : (needsCheckin ? <Heart size={14} /> : <CheckCircle size={14} />)}
          {needsCheckin ? 'Invia Check-in "Sto Bene"' : 'Aggiorna Check-in'}
        </button>
      </div>
    </div>
  );
}
